function answersAreCorrect(expectedGridItemIndices) {
    console.log(`evaluating round: \n${expectedGridItemIndices}\n${clickedItems}`)

    /* check if they contain same items in same order */
    if (expectedGridItemIndices.toString() === clickedItems.toString()) {
        console.log('✅ correct')
        correctAnswerAnimation()
        return true
    } else {
        console.log('❌ incorrect')
        wrongAnswerAnimation()
        setComment('Leider falsch. Übung abgeschlossen.')
        document.querySelector('#start-button').classList.remove('hidden')
        return false
    }

    
}